import { HomeTypeEnum, OwnershipType, ColumnChoiceType } from '@/enums';
import strings from '@/language/Swedish';

const defaultCoordinates = {
  lat: 59.32522271756051,
  lng: 18.070657040456123,
};

const defaultRectangleCoords = {
  north: 59.45,
  south: 59.15,
  east: 18.2,
  west: 17.8,
};

const defaultColumnOptions = [
  { label: strings.data.coOperative, value: ColumnChoiceType.coOperative },
  { label: strings.data.littleHouse, value: ColumnChoiceType.littleHouse },
  { label: strings.data.salesInfo, value: ColumnChoiceType.sold },
  { label: strings.data.adInfo, value: ColumnChoiceType.ads },
  { label: strings.data.realEstateInfo, value: ColumnChoiceType.realEstate },
  { label: strings.data.ownChoice, value: ColumnChoiceType.ownChoice },
] as const;

const defaultCategories = [HomeTypeEnum.apartment];
const defaultFormOfOwnership = [OwnershipType.coOperativeApartment];

const defaultMarketRefParams = {
  construction_year_reference: null,
  floor_reference: null,
  floors_reference: null,
  living_area_reference: null,
  monthly_fee_reference: null,
  rooms_reference: null,
};

const defaultMarketFilterParams = {
  ownership_type: defaultFormOfOwnership,
  ancillary_area_min: null,
  ancillary_area_max: null,
  home_type: defaultCategories,
  construction_year_min: null,
  construction_year_max: null,
  monthly_fee_min: null,
  monthly_fee_max: null,
  living_area_min: null,
  living_area_max: null,
  price_min: null,
  price_max: null,
  rooms_min: null,
  rooms_max: null,
  registered_date_min: new Date(2014, 0) as Date,
  registered_date_max: new Date() as Date,
};

export {
  defaultRectangleCoords,
  defaultCategories,
  defaultCoordinates,
  defaultFormOfOwnership,
  defaultMarketFilterParams,
  defaultMarketRefParams,
  defaultColumnOptions,
};
